<button (click)="openLightbox()" class="video-lightbox__thumbnail">
  <div class="video-lightbox__thumbnail-img">
    <app-picture [data]="videoData.thumbnail"></app-picture>
    <div class="video-lightbox__thumbnail-img-play"></div>
  </div>
</button>

<app-modal-video
  *ngIf="isShow"
  [data]="videoData"
  [isShow]="isShow"
  (close)="closeLightbox()"
></app-modal-video>
